module.exports = __webpack_public_path__ + "static/media/party_selection.3d8d987b.svg";